interface MetricData {
  metricId: string;
  quantity: number;
  allowAdditionalItem: boolean;
  additionalItemValue: number;
}

interface ItemData {
  metric: MetricData;
  total: number;
  exceededPlan: number;
  planUsage: number;
}

export class AdvancedDailyEngagedUserUsageTotal {
  userConversationTotal!: number;
  prospectConversationTotal!: number;
  dailyEngagedUsersTotal!: number;
  activeMessageTotal!: number;
  dailyEngagedUserAITotal!: number;

  constructor(raw: { items: ItemData[] }) {
    // userConversationTotal holds whichever of the two mutually-exclusive metrics was requested (billing-deu-ai-enabled toggles between them)
    this.userConversationTotal = raw.items.find(item => item.metric.metricId === 'UserConversation' || item.metric.metricId === 'DailyEngagedUserAI')?.total ?? 0;
    this.prospectConversationTotal = raw.items.find(item => item.metric.metricId === 'ProspectConversation')?.total ?? 0;
    this.dailyEngagedUsersTotal = raw.items.find(item => item.metric.metricId === 'DailyEngagedUser')?.total ?? 0;
    this.activeMessageTotal = raw.items.find(item => item.metric.metricId === 'ActiveMessage')?.total ?? 0;
    this.dailyEngagedUserAITotal = raw.items.find(item => item.metric.metricId === 'DailyEngagedUserAI')?.total ?? 0;
  }
}